import { render, staticRenderFns } from "./cliente-form.vue?vue&type=template&id=548bd32c&scoped=true"
import script from "./cliente-form.vue?vue&type=script&lang=js"
export * from "./cliente-form.vue?vue&type=script&lang=js"
import style0 from "./cliente-form.vue?vue&type=style&index=0&id=548bd32c&prod&scoped=true&lang=css"
import style1 from "./cliente-form.vue?vue&type=style&index=1&id=548bd32c&prod&lang=css"
import style2 from "./cliente-form.vue?vue&type=style&index=2&id=548bd32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548bd32c",
  null
  
)

export default component.exports